/**
 * @author lifei
 * 功能：转换路由 / -> -
 */
export const getRouteName = (path: string) => path.replace(/^\/|\/$/g, '').replace(/\//g, '-')
